import { getRedirectToLoginURL, getRedirectToLoginURLWithEmail } from "@/common/loginRedirect";
import router from "@/routes";
import { useUserStore } from "@/stores/user";

export function goToSecurityPage() {
  const userStore = useUserStore();
  // Logic to navigate to the security page in My Account
  const url = `${window.location.origin}/security`;

  //User is logged in
  if (userStore.isEstablishedAccount) {
    router.push("/security");
    return;
  }

  if (userStore.email) {
    window.location.href = getRedirectToLoginURLWithEmail(url, userStore.email);
  } else {
    window.location.href = getRedirectToLoginURL(url);
  }
}
